export const SET_ADVISOR_VIEW = 'SET_ADVISOR_VIEW';
export const toggleAdvisorView = (isAdvisorView: boolean) => ({ type: SET_ADVISOR_VIEW, isAdvisorView });
